export { default as LoginFormMock } from './login';
export { default as RegisterFormMock } from './register';
export { default as PasswordFormMock } from './password';
